import { cn } from "@client/lib/cn";

interface RichContentProps {
  html: string;
  className?: string;
}

/**
 * Renders admin-authored HTML. Safe only because the API sanitizes it server-side
 * (server/src/lib/html-sanitizer.ts) — never pass unsanitized input here.
 */
export function RichContent({ html, className }: RichContentProps) {
  return (
    <div
      className={cn("rich-content prose prose-invert max-w-none", className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
